import type { PlantRouting } from '../types/domain.types';

import { CTL_ENDPOINTS } from './endpoints';
import { request } from './http';
import { parseOrThrow, plantRoutingSchema } from './schemas';

export const fetchPlantRouting = async (plantId: string, signal: AbortSignal | undefined): Promise<PlantRouting> => {
  const raw = await request('get', CTL_ENDPOINTS.PLANT_ROUTING(plantId), { signal });
  return parseOrThrow(plantRoutingSchema, raw, 'plant routing');
};
